const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const getApiBase = (): string => {
  return import.meta.env.VITE_API_URL || '';
};

export const uploadToS3 = async (file: File, folder: string = 'uploads'): Promise<{ url: string; key: string }> => {
  try {
    console.log("S3'e yükleme başlatılıyor:", { dosyaAdı: file.name, dosyaTipi: file.type, dosyaBoyutu: file.size });

    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    const res = await fetch(`${getApiBase()}/api/upload`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formData,
    });

    if (!res.ok) {
      const error = await res.json().catch(() => ({ error: 'Upload failed' }));
      throw new Error(error.error || 'Dosya yükleme başarısız');
    }

    const data = await res.json();
    console.log("S3 yükleme başarılı:", data.url);

    // URL'den key'i çıkar
    const urlParts = new URL(data.url);
    const key = urlParts.pathname.substring(1); // leading slash'ı kaldır

    return {
      url: data.url,
      key: key,
    };
  } catch (error) {
    console.error("S3 yükleme hatası:", error);
    throw error;
  }
};

export const isBrowser = () => {
  return typeof window !== 'undefined';
};
